import "./plan-name.scss";
import { Badge, BadgeType } from "../../../../components/badge/badge";

interface IPlanNameProps {
    isDefault?: boolean;
    isNew?: boolean;
    children: React.ReactNode,
}

const PlanName: React.FC<IPlanNameProps> = ({ isDefault, isNew, children }) => {
    return (
        <div className="subscription-plan-name">
            {children}
            {isDefault && <Badge text='Default' />}
            {isNew && <Badge text='New' type={BadgeType.WARNING} />}
        </div>
    );
};

export default PlanName;
